// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"2360b629","477":"2360b629","570":"2ef81caf","810":"2360b629"}[chunkId] + ".chunk.css";
};